import { createAsyncThunk } from "@reduxjs/toolkit";
import NotifyConfig from "../../utils/NotifyConfig";
import LeaderboardService from "../services/leaderboardService";

export const LeaderboardThunk = createAsyncThunk(
  "leaderboard/get",
  async ({ level = "global" } = {}, { rejectWithValue }) => {
    try {
      const response = await LeaderboardService.getLeaderboard({ level });

      return response;
    } catch (err) {
      NotifyConfig.notifyErrorServer(err.response?.data?.error?.text);
      console.error(err);
      // Reject (rather than fulfill with []) so a failed refresh keeps the
      // currently displayed list instead of blanking it into "no results".
      return rejectWithValue(err.response?.data ?? null);
    }
  },
);
